@if (loaded) {
    <div class="row">
        <div class="form-group col">
            @if (isTreeSource) {
                <cerrix-select-tree
                    [multiselect]="isMultiselect"
                    [tree]="field.SourceData"
                    [(value)]="selectedOptions"
                    [readonly]="readonly"
                    (onChange)="emitChange()"
                    (onChangeSingle)="emitChange()"
                >
                </cerrix-select-tree>
            } @else {
                <ng-select
                    id="sourcedata-{{ field.ID }}"
                    name="sourcedata-{{ field.ID }}"
                    [multiple]="isMultiselect"
                    [items]="field.SourceData"
                    [(ngModel)]="selectedOptions"
                    bindLabel="Name"
                    bindValue="ID"
                    [disabled]="readonly"
                    (change)="emitChange()"
                    (clear)="emitChange()"
                    [closeOnSelect]="!isMultiselect"
                >
                </ng-select>
            }
        </div>
    </div>
}
